import styled from 'styled-components';

export const UnitContainer = styled.div`
  padding: 13px 10px;
`;
